import { Navigate, Outlet, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import API_URL from "../../localhost/config"; //Importa la variable global

const ProtectedRoute = ({ redirectPath = "/" }) => {
  //const idUsuario = localStorage.getItem("userId");
  const { idTorneo } = useParams();
  const [esSuTorneo, setEsSuTorneo] = useState(null); // Estado para manejar la carga asíncrona

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  //Loading
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si los datos están cargados

  useEffect(() => {
    if (token) {
      setIsLoading(true);
      axios
        .get(`${API_URL}/torneos`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const esSuTorneo = response.data.some(
            (turno) => turno.id == idTorneo
          );
          setEsSuTorneo(esSuTorneo);
        })
        .catch(() => setEsSuTorneo(false)); // Manejar errores
      setIsLoading(false);
    } else {
      setEsSuTorneo(false);
    }
  }, [idTorneo, token]);

  // Renderear el componente basado en el estado
  if (esSuTorneo === null) {
    // Cargando datos
    return <div>Cargando...</div>;
  }

  if (!esSuTorneo) {
    // No es su torneo, redirigir
    return <Navigate to={redirectPath} replace />;
  }

  // Es su torneo, renderizar Outlet
  return <Outlet />;
};

export default ProtectedRoute;
